import React from 'react'
import { makeStyles } from '@mui/styles';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Offer_request_View from './offer_request_View';


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
      marginBottom: 16,
    },
    table: {
      minWidth: 750,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  }));
  
  


function DemandeAppel_Dialog({open,handleClose,offerClicked}){

    const classes = useStyles();

    return (
        <Dialog disableEnforceFocus fullScreen open={open} onClose={handleClose} className="my_full_dialog contract_full_dialog">
            <AppBar className={classes.appBar}  >
                <Toolbar style={{backgroundColor:'#343a40'}} >
                <div className='page_title'>
                  <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close" >
                      <CloseIcon className="my_icon" />
                  </IconButton>
                  <span>Soumissions</span>
                </div>
                </Toolbar>
            </AppBar>
            <Offer_request_View key={'submissions_table'} offerClicked={offerClicked} />
        </Dialog>
    )
}

export default DemandeAppel_Dialog;
